import { render } from "./BankCollectedDetail.vue?vue&type=template&id=60ea69df&scoped=true"
import script from "./BankCollectedDetail.vue?vue&type=script&lang=js"
export * from "./BankCollectedDetail.vue?vue&type=script&lang=js"

import "./BankCollectedDetail.vue?vue&type=style&index=0&id=60ea69df&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ea69df"]])

export default __exports__